import { appRoute } from "routes/app/home.runtime"
import { makeLazy } from "lib/make-lazy"

const MyConformityList = makeLazy(() => import("./my-conformity-list"), "MyConformityList")
const ConformityForm = makeLazy(() => import("./conformity-form"), "ConformityForm")
appRoute.register("conformity", <MyConformityList $lazy />)
appRoute.register("conformity/:id", <ConformityForm $lazy />)
